var _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgAlertFilled(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "var(--yellow-6)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2074 1.85155C22.2392 0.0494783 19.7608 0.0494844 18.7926 1.85156L0.328946 36.2153C-0.62072 37.9828 0.599304 40.1667 2.53637 40.1667H39.4636C41.4007 40.1667 42.6207 37.9828 41.6711 36.2153L23.2074 1.85155ZM23.2707 12.1667H19.1051L19.387 28.4217H22.9888L23.2707 12.1667ZM19.387 31.1779C18.9068 31.6581 18.6667 32.2532 18.6667 32.9631C18.6667 33.673 18.9068 34.2785 19.387 34.7796C19.8673 35.2599 20.4623 35.5 21.1723 35.5C21.9031 35.5 22.5086 35.2599 22.9888 34.7796C23.469 34.2994 23.7092 33.6939 23.7092 32.9631C23.7092 32.2532 23.469 31.6581 22.9888 31.1779C22.5086 30.6976 21.9031 30.4575 21.1723 30.4575C20.4623 30.4575 19.8673 30.6976 19.387 31.1779Z",
    fill: "#FBBC00"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertFilled);
export default __webpack_public_path__ + "static/media/alertFilled.91ede50675ea8886fd5add121fdf2926.svg";
export { ForwardRef as ReactComponent };